<template lang="pug">
.v-modal(
  :class="`${!props.open && 'hidden'} md_block \ fixed md_static \ z-50 md_z-auto \ w-full md_w-auto \ h-full md_h-auto \ inset-0 \ bg-white`"
)
  slot
</template>

<script lang="ts" setup>
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})
</script>
